import { DeleteFilled, PlayCircleFilled, PlusOutlined } from '@ant-design/icons'
import { message, Modal, Progress, Spin } from 'hljd'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImageUploader from './ImageUploader'
import Store from './store'
import upload from './util/upload'
import { checkDuration } from './util/validate'

@observer
class VideoUploader extends Component {
  constructor() {
    super()
    this.store = new Store()
    this.videoSelector = React.createRef()
  }
  componentDidMount() {
    const { video } = this.props
    this.store.initVideoByMedia(video)
  }

  componentDidUpdate(pre_props) {
    if (!this.props || !this.props.modal_visible) {
      return
    }

    // 外部进行了改变了modal_visible的值
    if (this.props && this.props.modal_visible && !pre_props.modal_visible) {
      this.showModal()
    }
  }

  getVideoFrames = (video, frameOffsets) => {
    if (!frameOffsets || !video || frameOffsets.length < 1) {
      return []
    }

    return frameOffsets.map(
      offset =>
        `${video.path}?vframe/jpg/offset/${offset}/w/${video.width}/h/${
          video.height
        }`
    )
  }

  handleOk = () => {
    const store = this.store
    if (store.saving) {
      return
    }
    if (!store.video || !store.video.path) {
      message.warning('请上传视频')
      return
    }
    if (!store.video.cover_path) {
      message.warning('请选择视频封面')
      return
    }
    // 只有当视频资料更新时保存
    if (
      !store.origin_video ||
      store.origin_video.media_id !== store.video.media_id ||
      store.origin_video.cover_path !== store.video.cover_path
    ) {
      //  更新上层视频资料
      store.outside_cover = store.video.cover_path
      this.props.onVideoOk && this.props.onVideoOk(store.video)
    } else {
      this.props.onVideoCancel &&
        this.props.onVideoCancel(store.video, store.origin_video)
    }
    store.triggerModal()
  }

  handleCancel = () => {
    const store = this.store
    let isRecover = true
    store.cancelUploadVideo(isRecover)
    // 模态框中点击取消按钮
    this.props.onVideoCancel &&
      this.props.onVideoCancel(store.video, store.origin_video)

    store.triggerModal()
  }

  handleImgUpload = (type, up, link, file, info) => {
    this.store.handleCoverClick(link)
  }

  initUploader = () => {
    const store = this.store
    const {
      upload_url,
      domain_url,
      video_uptoken_url,
      ...rest
    } = this.props.uploadOptions
    // 初始化上传控件
    setTimeout(
      () =>
        (store.video_uploader = upload({
          browseButton: this.videoSelector.current,
          events: {
            fileUploaded: this.handleVideoUploaded,
            beforeUpload: this.beforeUpload,
            uploadProgress: store.uploadProgress,
            onError: this.props.onVideoError
          },
          param: {
            type: 'video',
            upload_url,
            uptoken_url: video_uptoken_url,
            domain_url,
            max: this.props.max,
            mime_types: this.props.video_types,
            ...rest
          }
        }))
    )
  }

  handleVideoUploaded = (up, file, res) => {
    // 传给外部
    this.store.fileUploaded(up, file, res)
    this.props.onVideoUploaded && this.props.onVideoUploaded(up, file, res)
  }

  beforeUpload = (up, file) => {
    const { onBeforeUpload } = this.props

    if (onBeforeUpload) {
      onBeforeUpload(up, file)
        .then(res => {
          this.store.beforeUpload(up, file)
        })
        .catch(err => {
          // 注意：异步 removeFile 并不会中断七牛上传流程，只是将正在上传的文件取消掉
          up.removeFile(file)
        })
    } else {
      this.store.beforeUpload(up, file)
    }
  }

  /**
   * 在modal中临时删除视频
   * @memberof VideoUploader
   */
  handleVideoTempDelete = () => {
    this.store.deleteVideo()
    this.initUploader()
  }

  /**
   * 在外部直接视频
   * @memberof VideoUploader
   */
  handleVideoDelete = () => {
    this.store.outside_cover = null

    this.store.cancelUploadVideo()
    this.props.onVideoDelete && this.props.onVideoDelete()
  }

  showModal = () => {
    const { video, modal_visible } = this.props
    this.store.triggerModal()

    // 当通过node节点打开模态框时，初始化video
    if (modal_visible) {
      this.store.initVideoByMedia(video)
    }

    // 显示modal时已经存在video,则拷贝原video
    if (this.store.video) {
      this.store.initOriginVideo()
      return
    }

    this.initUploader()
  }

  renderVideoContainer = () => {
    const store = this.store
    const { max } = this.props
    if (!store.video) {
      return (
        <div>
          <div
            className="hlj-video-selector"
            ref={this.videoSelector}
            onClick={this.selectVideo}
          >
            <div className="hlj-tips">
              <PlusOutlined className="hlj-plus" />
              <span>视频比例建议为16:9</span>
              <span>
                视频大小不超过
                {max || '500mb'}
              </span>
            </div>
          </div>

          {store.loading && (
            <div
              className="hlj-progress"
              onClick={event => event.stopPropagation()}
            >
              <Progress
                className="hlj-progress-loader"
                percent={store.upload_percent}
                status="active"
              />
            </div>
          )}
        </div>
      )
    } else {
      return (
        <Spin spinning={store.loading}>
          <video
            className="hlj-video"
            onError={e => store.handleVideoLoadError(e)}
            controls
            src={store.video.compromise_path || store.video.trans_path}
          />
          {store.video.compromise_path === 'not support' && (
            <div className="hlj-video-uploader-selected-cover">
              <img src={store.video.cover_path || store.video.frames[0]} />
              <PlayCircleFilled
                className="hlj-icon"
                onClick={() => message.warning('该视频格式暂不支持预览')}
              />
            </div>
          )}
          <DeleteFilled
            className="hlj-delete-icon"
            onClick={this.handleVideoTempDelete}
          />
        </Spin>
      )
    }
  }

  renderVideoTipModal = () => {
    Modal.info({
      maskClosable: true,
      title: '修改视频尺寸攻略',
      width: 800,
      centered: true,
      content: (
        <video
          className="hlj-cut-video"
          controls
          src="//qnm.hunliji.com/o_1cjkbr6a61gt31t3j1ij9vgv1d6o7.mp4"
        />
      ),
      onOk() {}
    })
  }

  renderVideoFrames = ({ frames, cover_path }) => {
    if (!frames || frames.length < 1) {
      return
    }

    return (
      <div className="hlj-frame-selector">
        <div className="hlj-frame-title">封面选择：</div>
        {frames.map((frame, index) => (
          <div
            className={
              'hlj-frame ' + (frame === cover_path ? 'hlj-frame-selected' : '')
            }
            key={index}
            onClick={() => this.store.handleCoverClick(frame)}
          >
            <img src={frame} alt="封面预选图" />
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { hide_outside_cover } = this.props
    const store = this.store
    return (
      <div>
        {!hide_outside_cover && (
          <div>
            <div className="hlj-video-upload-header-text">上传视频详情</div>
            <div className="hlj-video-uploader" onClick={this.showModal}>
              {!store.video || !store.outside_cover ? (
                <PlusOutlined className="hlj-uploader-plus" />
              ) : (
                <div className="hlj-video-previewer">
                  <div className="hlj-cover">
                    <img src={store.outside_cover} />

                    <PlayCircleFilled className="hlj-icon" />

                    <div
                      className="hlj-mask"
                      onClick={e => e.stopPropagation()}
                    >
                      <div className="hlj-btn">
                        <span onClick={this.showModal}> 编 辑 </span>
                        <span onClick={this.handleVideoDelete}> 删 除 </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        <Modal
          title={<div style={{ fontWeight: 'bold' }}>视频素材</div>}
          maskClosable={false}
          destroyOnClose={true}
          width={750}
          keyboard={false}
          visible={store.modal_visible}
          onOk={this.handleOk}
          okText="确定"
          cancelText="取消"
          onCancel={this.handleCancel}
        >
          <div className="hlj-content-container">
            <div className="hlj-container-title">上传视频：</div>
            <div className="hlj-video-selector-container">
              {this.renderVideoContainer()}

              <div className="hlj-size-msg">
                <span>如何修改视频尺寸？</span>
                <a href="javascript:;" onClick={this.renderVideoTipModal}>
                  请点击这里查看攻略
                </a>
              </div>
            </div>
          </div>

          {store.video && (
            <div className="hlj-cover-container">
              <div className="hlj-container-title">
                <span>视频封面：</span>
              </div>
              <div className="hlj-cover-uploader">
                <ImageUploader
                  uploadComplete={this.handleImgUpload.bind(this, 'cover_path')}
                  uploadOptions={this.props.uploadOptions}
                  onError={this.props.onImageError}
                  inlineStyle={{ height: 170 }}
                  link={store.video.cover_path}
                  limt={{ width: 1280, height: 720 }}
                  displaySize={{ width: 304, height: 170 }}
                  text="支持JPG、PNG格式"
                  isCrop={true}
                  aspect={16 / 9}
                />

                {store.video.cover_path && (
                  <div className="hlj-selected-cover">
                    <img src={store.video.cover_path} alt="封面预选图" />
                  </div>
                )}
              </div>

              <div className="hlj-cover-selector-container">
                {this.renderVideoFrames(store.video)}
              </div>
            </div>
          )}
        </Modal>
      </div>
    )
  }
}

VideoUploader.defaultProps = {
  uploadOptions: {}
}

VideoUploader.propTypes = {
  // 允许上传的最大视频，默认500M，eg: '500mb'
  max: PropTypes.string,
  // 视频
  video: PropTypes.object,
  // 控制模态框的显示，一般在hide_outside_cover为true时使用
  modal_visible: PropTypes.bool,
  // 是否隐藏外部封面操作区
  hide_outside_cover: PropTypes.bool,
  // 上传限制类型(例如'mp4,mov,avi', 默认='flv,mp4,mkv,wmv,avi,mov,rm,rmvb,mpeg')
  video_types: PropTypes.string,
  // 上传资源的服务器配置
  uploadOptions: PropTypes.shape({
    // 上传资源的地址：
    upload_url: PropTypes.string,
    // 上传视频前，从服务器获取token的地址
    video_uptoken_url: PropTypes.string,
    // 上传图片前，从服务器获取的token地址
    image_uptoken_url: PropTypes.string,
    // 上传视频的仓库地址
    domain_url: PropTypes.string,
    region: PropTypes.string,
    tokenPath: PropTypes.func
  }),

  // 点击模态框确定时回调
  onVideoOk: PropTypes.func,
  // 视频上传成功后的回调
  onVideoUploaded: PropTypes.func,
  // 点击模态框取消时回调，参数（video, origin_video）
  onVideoCancel: PropTypes.func,
  // 点击外部封面的删除按钮，视频删除时回调
  onVideoDelete: PropTypes.func,
  // 视频上传失败
  onVideoError: PropTypes.func,
  // 图片上传失败
  onImageError: PropTypes.func,
  // 获取上传文件，未上传到服务器前
  onBeforeUpload: PropTypes.func
}

VideoUploader.checkDuration = checkDuration

export default VideoUploader
